import React from "react";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { TaskCard } from "../../pages/plan/TaskCard";
import { get } from "../../utils/get";
import { v4 as uuidv4 } from "uuid";

export const PlanCard = ({ cardData }: any) => {
  return (
    <>
      {cardData.map((cardItem, index) => (
        <PlanItemContainer key={index}>
          <PlanItemHeader backgroundColor={cardItem.backgroundColor}>
            <PlanItemHeaderText color={cardItem.color}>
              {cardItem.headerText}
            </PlanItemHeaderText>
          </PlanItemHeader>
          <PlanItemMain>
            <TitleText></TitleText>
            <div>
              {get(cardItem, "allTasks", []).map((item, index) => (
                <TaskCard key={uuidv4()} taskCardData={item} />
              ))}
            </div>
          </PlanItemMain>
        </PlanItemContainer>
      ))}
    </>
  );
};
const PlanItemContainer = styled.div`
  display: grid;
  grid-template-rows: 4em auto 3em;
`;
const PlanItemHeader = styled.div<{ backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor || "#EAEFFF"};
  padding: 0.5em 1em;
  margin-bottom: 0.5em;
  border-radius: 8px;
  align-self: center;
`;
const PlanItemHeaderText = styled.label<{ color?: string }>`
  color: ${(props) => props.color || "#01A8CE"};
  font-size: 12px;
  text-align: left;
`;

const PlanItemMain = styled.div`
  display: grid;
  grid-template-rows: 2.5em auto;
  background-color: #fff;
  border-radius: 8px;
  padding: 1em 1.5em;
`;
